import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class PlantTank extends React.Component {
  componentWillMount() {
    this.props.createPlantTank({
      props: this.props.defaultProps,
    });
  }

  render() {
    return (
      <ul>
        <li
          id={"PlantTank_"+this.props.id}
          className={'PlantTank'}>
          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

PlantTank.propTypes = {
  createPlantTank: PropTypes.func,
};

PlantTank.defaultProps = {};
